import { useWidgetContext } from 'widgets/WidgetContext';
import { useSelector } from 'react-redux';
import State from 'store/State';
import {
    createSymbolEventsWidgetRequestUid,
    getRequestUidForSymbol,
} from 'widgets/corpActions/store/data/SymbolEventsRequestHelpers';
import { selectCorporateActionsRequestState } from 'widgets/corpActions/store/data/selectors';
import { CorporateActionsWidgetConfigState } from 'widgets/corpActions/widget/store/config/CorporateActionsWidgetConfigState';
import { useEffect, useState } from 'react';
import { useServices } from 'app/hooks';

export function useCorporateActionsData() {
    const { widgetKey, widgetType } = useWidgetContext();
    const [streamKey, setStreamKey] = useState<string | undefined>(undefined);
    const state = useSelector((s: State) => s);
    const services = useServices();

    useEffect(() => {
        createSymbolEventsWidgetRequestUid(state, services, {
            widgetKey,
            widgetType,
        }).then((res) => setStreamKey(res));
    }, [services, state, setStreamKey, widgetType, widgetKey]);

    return useSelector((state: State) => {
        return streamKey
            ? selectCorporateActionsRequestState(state, streamKey)
            : undefined;
    });
}

export function useCorporateActionsStreamedData(
    symbol: string,
    config: CorporateActionsWidgetConfigState
) {
    const requestUid = getRequestUidForSymbol(symbol, config);
    return useSelector((state: State) => {
        return requestUid
            ? selectCorporateActionsRequestState(state, requestUid)
            : undefined;
    });
}
